import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsvGeneratorService {
  constructor() { }
  convertToCsv(data: any[], header: string[], titulo?: string): string{
    const csvRows: string[]= [];
    const colunasPadding = '\t\t\t\t';

    if (titulo) {
        csvRows.push(titulo);
    }

    csvRows.push(header.map((field) => field.toUpperCase() + colunasPadding).join(';'));

    data.forEach((row) => {
      const values = header.map((field) => {
        const value = row[field];
        return value !== undefined && value !== null ? `"${value + colunasPadding}"` : '""';
      });
     csvRows.push(values.join(';'))

    })
    return csvRows.join('\n');
  }
  downloadCSV(data: any[], header: string[], fileName: string, titulo?: string): void {
    const csvData = this.convertToCsv(data, header, titulo);

    const bom = '\uFEFF';
    const blob = new Blob([bom + csvData], { type: 'text/csv;charset=utf-8' });

    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${fileName}.csv`);
      link.click();
    }
  }
}

